import Airtable from 'airtable';

// Configure Airtable
const base = new Airtable({
  apiKey: process.env.REACT_APP_AIRTABLE_API_KEY
}).base(process.env.REACT_APP_AIRTABLE_BASE_ID);

// Allow overriding the table name via env; default to "Table 1"
const CASE_STUDIES_TABLE =
  process.env.REACT_APP_AIRTABLE_CASE_STUDIES_TABLE || 'Table 1';

function getFirstAvailable(record, fieldNames) {
  for (const name of fieldNames) {
    const value = record.get(name);
    if (value !== undefined && value !== null && value !== '') {
      return value;
    }
  }
  return undefined;
}

function coerceText(value) {
  if (Array.isArray(value)) {
    // If the field is a linked-record array or multi-value, join for display
    return value.join('\n\n');
  }
  return value;
}

export const fetchCaseStudies = async () => {
  try {
    const records = [];
    
    await base(CASE_STUDIES_TABLE)
      .select({
        filterByFormula: "{Status} = 'Published'",
        sort: [{ field: 'Order', direction: 'asc' }]
      })
      .eachPage((pageRecords, fetchNextPage) => {
        records.push(...pageRecords);
        fetchNextPage();
      });

    return records.map(record => ({
      id: record.id,
      clientName: record.get('Client Name'),
      title: record.get('Title'),
      subtitle: record.get('Subtitle'),
      slug: record.get('Slug'),
      summary: record.get('Summary'),
      challenge: record.get('Challenge'),
      roleAndApproach: record.get('Role and Approach'),
      findings: record.get('Findings'),
      outcomes: record.get('Outcomes'),
      keyDeliverables: record.get('Key Deliverables'),
      quotes: coerceText(
        getFirstAvailable(record, [
          'Quotes',
          'Quote',
          'Client Quote',
          'Client Quotes',
          'Client Feedback'
        ])
      ),
      lessonsLearned: record.get('Lessons Learned'),
      heroImageUrl: record.get('Hero Image') ? record.get('Hero Image')[0]?.url : null,
      galleryImages: record.get('Image Gallery') ? record.get('Image Gallery').map(img => ({
        id: img.id,
        url: img.url,
        filename: img.filename
      })) : [],
      status: record.get('Status'),
      order: record.get('Order'),
      featuredOnHome: record.get('Featured on Home')
    }));
  } catch (error) {
    console.error('Error fetching case studies from Airtable:', error);
    throw error;
  }
};

export const fetchCaseStudyBySlug = async (slug) => {
  try {
    console.log('Searching for case study with slug:', slug);
    console.log('API Key exists:', !!process.env.REACT_APP_AIRTABLE_API_KEY);
    console.log('Base ID exists:', !!process.env.REACT_APP_AIRTABLE_BASE_ID);

    // First, let's see all records to debug
    const allRecords = await base(CASE_STUDIES_TABLE).select().firstPage();
    console.log('All records in table:', allRecords.length);
    allRecords.forEach((record, index) => {
      console.log(`Record ${index + 1}:`, {
        slug: record.get('Slug'),
        status: record.get('Status'),
        clientName: record.get('Client Name'),
        title: record.get('Title')
      });
    });

    const records = await base(CASE_STUDIES_TABLE)
      .select({
        filterByFormula: `AND({Slug} = '${slug}', {Status} = 'Published')`,
        maxRecords: 1
      })
      .firstPage();

    console.log('Records found:', records.length);

    if (records.length === 0) {
      return null;
    }

    const record = records[0];
    return {
      id: record.id,
      clientName: record.get('Client Name'),
      title: record.get('Title'),
      subtitle: record.get('Subtitle'),
      slug: record.get('Slug'),
      summary: record.get('Summary'),
      challenge: record.get('Challenge'),
      roleAndApproach: record.get('Role and Approach'),
      findings: record.get('Findings'),
      outcomes: record.get('Outcomes'),
      keyDeliverables: record.get('Key Deliverables'),
      quotes: coerceText(
        getFirstAvailable(record, [
          'Quotes',
          'Quote',
          'Client Quote',
          'Client Quotes',
          'Client Feedback'
        ])
      ),
      lessonsLearned: record.get('Lessons Learned'),
      heroImageUrl: record.get('Hero Image') ? record.get('Hero Image')[0]?.url : null,
      galleryImages: record.get('Image Gallery') ? record.get('Image Gallery').map(img => ({
        id: img.id,
        url: img.url,
        filename: img.filename
      })) : [],
      status: record.get('Status'),
      order: record.get('Order'),
      featuredOnHome: record.get('Featured on Home')
    };
  } catch (error) {
    console.error('Error fetching case study by slug:', error);
    throw error;
  }
};

const SKILLS_TABLE = 'Skills'; // New table for skills

export const fetchSkills = async () => {
  try {
    const records = [];

    await base(SKILLS_TABLE)
      .select({
        filterByFormula: "{Status} = 'Published'",
        sort: [{ field: 'Order', direction: 'asc' }]
      })
      .eachPage((pageRecords, fetchNextPage) => {
        records.push(...pageRecords);
        fetchNextPage();
      });

    return records.map(record => ({
      id: record.id,
      title: record.get('Title'),
      description: record.get('Description'),
      imageUrl: record.get('Image') ? record.get('Image')[0]?.url : null,
      order: record.get('Order'),
      status: record.get('Status')
    }));
  } catch (error) {
    console.error('Error fetching skills from Airtable:', error);
    throw error;
  }
};